import { QFilterGeneric } from './QFilterGeneric'

export class QFilterBPExclude extends QFilterGeneric {
  name = "business_process_exclude";
  class_name = "QFilterBPExclude";
  api_name = 'business_process_exclude';
  
  serialize(qfilters) {
    return encodeURIComponent(this.value);
  }
}
